import { Button } from '@askable/ui/core/button';
import _ from 'lodash';
import { Fragment } from 'react';
import { useQuery } from 'urql';

import { Dialog, LoadingOverlay } from 'components/common';
import { FindBookingSubmissionWithParticipantExclusion } from 'data/queries/bookingSubmission/findBookingSubmissionWithParticipantExclusion.query';
import { bookingUtils } from 'lib/booking';

import ConfirmationMessageInvitationDialog from './confirmationMessage';
import InvitationDialogContentContainer from './contentContainer';

const InviteParticipant = (props: any) => {
  let sessionAssigned = _.get(props, 'singleSession.session');
  const { isAvailableForSession } = props.singleSession;
  let { participant } = props.singleSession;
  if (props.isBulkInvite && _.size(props.bulkSession.participants) > 0) {
    participant = _.get(props, 'bulkSession.participants[0]');
  }

  if (bookingUtils.isOnlineTask(props.booking) || bookingUtils.isLongitudinal(props.booking)) {
    [sessionAssigned] = props.booking.session;
  }

  const [{ data, fetching }] = useQuery({
    query: FindBookingSubmissionWithParticipantExclusion,
    variables: { userId: _.get(participant, 'user._id'), bookingId: props.booking._id },
    requestPolicy: 'cache-and-network',
  });

  const previousAttendance = _.get(data, 'findBookingSubmission[0].previousAttendance[0]');

  const renderInviteTitle = () => {
    if (props.isBulkInvite && _.size(props.bulkSession.participants) > 0) {
      return (
        <p>
          Invite <strong>all {_.size(props.bulkSession.participants)}</strong> participants?
        </p>
      );
    }
    if (previousAttendance) {
      return (
        <p>
          You can't invite {_.get(participant, 'user.meta.identity.firstname')} to this study because{' '}
          {_.get(participant, 'user.meta.identity.gender') === 'male' ? 'he' : 'she'}'s been selected for another
          session already.
        </p>
      );
    }
    return (
      <p>
        Invite {_.get(participant, 'user.meta.identity.firstname')} {_.get(participant, 'user.meta.identity.lastname')}
        {!bookingUtils.isOnlineTask(props.booking) && !bookingUtils.isLongitudinal(props.booking)
          ? ' for this session?'
          : '?'}
      </p>
    );
  };

  const renderButtonsContainer = () => {
    // If it's not inviting multiple people on and it has previously attended a session for the client, it should display a message and an OKAY button to dismiss
    if (!props.isBulkInvite && previousAttendance) {
      return (
        <a onClick={props.onCloseInvitationDialog} className="link">
          OKAY
        </a>
      );
    }
    return (
      <Button variant="default" className="mt-5 max-w-[150px]" onClick={props.onConfirm}>
        {props.isBulkInvite ? `Send [${_.size(props.bulkSession.participants)}] Invites` : 'Send Invite'}
      </Button>
    );
  };

  return (
    <Dialog open={props.open} modal={false} onRequestClose={props.onCloseInvitationDialog}>
      <Fragment>
        {(props.loading || fetching) && <LoadingOverlay style={{ opacity: 0.8 }} />}
        {props.showConfirmationMessage ? (
          <ConfirmationMessageInvitationDialog {...props} />
        ) : (
          <Fragment>
            {renderInviteTitle()}
            <InvitationDialogContentContainer
              participant={participant}
              session={sessionAssigned}
              previousAttendance={previousAttendance}
              isAvailableForSession={isAvailableForSession}
              {...props}
            />
            <div className="buttonsContainer">{renderButtonsContainer()}</div>
          </Fragment>
        )}
      </Fragment>
    </Dialog>
  );
};

export default InviteParticipant;
